import {
  ADMINISTRATOR_USER,
  ASSOCIATION_USER,
  INSTITUTION_USER,
  REPORT_USER,
  SPECIALTY_USER,
  SUPER_USER,
} from '../actionTypes/Users/UserActionType';

export const canEditUserRole = (loggedAs, userRole, isEditAccess) => {
  switch (loggedAs) {
    case SUPER_USER:
      return [SUPER_USER, SPECIALTY_USER, INSTITUTION_USER, ASSOCIATION_USER, ADMINISTRATOR_USER, REPORT_USER].includes(
        userRole,
      );
    case ASSOCIATION_USER:
      return isEditAccess
        ? [INSTITUTION_USER, ASSOCIATION_USER, ADMINISTRATOR_USER, REPORT_USER].includes(userRole)
        : [ADMINISTRATOR_USER, REPORT_USER].includes(userRole);
    //return false;// disable edit for time being
    case INSTITUTION_USER:
      return [INSTITUTION_USER].includes(userRole);
    case ADMINISTRATOR_USER:
      return [REPORT_USER].includes(userRole);
    //return false;// disable edit for time being

    default:
      return false;
  }
};

export const canRemoveUserRole = (loggedAs, userRole) => {
  switch (loggedAs) {
    case SUPER_USER:
      return [SUPER_USER, SPECIALTY_USER, INSTITUTION_USER, ASSOCIATION_USER, ADMINISTRATOR_USER, REPORT_USER].includes(
        userRole,
      );
    case ASSOCIATION_USER:
      return [
        /*ASSOCIATION_USER ADMINISTRATOR_USER, REPORT_USER */
      ].includes(userRole);
    case INSTITUTION_USER:
      return [INSTITUTION_USER].includes(userRole);
    case ADMINISTRATOR_USER:
      return [REPORT_USER].includes(userRole);
    default:
      return false;
  }
};

export const canImpersonate = (loggedAs, userRole) => {
  switch (loggedAs) {
    case SUPER_USER:
      return [INSTITUTION_USER, SPECIALTY_USER, ASSOCIATION_USER, ADMINISTRATOR_USER, REPORT_USER].includes(userRole);
    case ASSOCIATION_USER:
      //return [/* ADMINISTRATOR_USER, REPORT_USER */].includes(userRole);
      return [ADMINISTRATOR_USER, REPORT_USER].includes(userRole);
    case INSTITUTION_USER:
      return false;
    case ADMINISTRATOR_USER:
      return [REPORT_USER].includes(userRole);
    case REPORT_USER:
      return false;
    default:
      return false;
  }
};

export const getUserRoleList = (role) => {
  switch (role) {
    case SUPER_USER:
      return [
        { id: 'ASSOCIATION_USER', name: 'Association User' },
        { id: 'INSTITUTION_USER', name: 'Institution User' },
        { id: 'ADMINISTRATOR_USER', name: 'Organization Administrator' },
        { id: 'REPORT_USER', name: 'Organization Report User' },
        { id: 'SUPER_USER', name: 'Super User' },
      ];
    case ASSOCIATION_USER:
      return [{ id: 'ASSOCIATION_USER', name: 'Association User' }];
    case ADMINISTRATOR_USER:
      return [{ id: 'REPORT_USER', name: 'Organization Report User' }];
    case INSTITUTION_USER:
      return [{ id: 'INSTITUTION_USER', name: 'Institution User' }];
    case REPORT_USER:
      return [];
    default:
      return [];
  }
};
